<div>
  <div class="mat-h3">
    Allgemeine Einstellungen
  </div>
  <p>
    Hier legen Sie fest, wie die von den Buchhaltungssystemen zurückgegebene CSV-Datei mit der offenen Postenliste interpretiert werden soll.
  </p>
  <ul>
    <li>
      <div class="mat-h3">
        Import-Modus
      </div>
      <p>
        Wählen Sie die benötigten Importoptionen aus.
      </p>
      <ul>
        <li>
          <div class="mat-h4">
            Keine Kopfzeile
          </div>
          <p>
            Aktivieren Sie diese Option, wenn die importierte CSV-Datei keine Kopfzeilen enthält.
          </p>
        </li>
        <li>
          <div class="mat-h4">
            Saldo aggregieren
          </div>
          <p>
            Wenn die offene Postenliste Bewegungsdaten enthält, werden diese in einer Saldenliste zusammengefasst.
            Aktivieren Sie diese Option, um die Aggregation vorzunehmen.
          </p>
        </li>
        <li>
          <div class="mat-h4">
            UTF8
          </div>
          <p>
            Standardmäßig wird eine ANSI-kodierte CSV-Datei erwartet.
            Aktivieren Sie diese Option, wenn Ihre CSV-Datei im UTF-8-Format vorliegt.
          </p>
        </li>
        <li>
          <div class="mat-h4">
            Haben invertieren
          </div>
          <p>
            Aktivieren Sie diese Option, wenn die Soll/Haben-Kennungen in Ihrer CSV-Datei invertiert sind.
          </p>
        </li>
      </ul>
    </li>
    <li>
      <div class="mat-h3">
        Formatierung
      </div>
      <p>
        Hier können Sie das Format der Datumszellen und Dezimalseparatoren in der CSV-Datei festlegen. Die verfügbaren Optionen sind:
       </p>
      <ul>
        <li>
          <div class="mat-h4">
            DE (Deutsch)
          </div>
          <p>
            Das Datum wird im Format TT.MM.JJJJ dargestellt, und der Dezimalseparator ist ein Komma (,).
          </p>
        </li>
        <li>
          <div class="mat-h4">
            UK (Britisch)
          </div>
          <p>
            Das Datum wird im Format TT/MM/JJJJ angezeigt, und der Dezimalseparator ist ein Punkt (.).
          </p>
        </li>
        <li>
          <div class="mat-h4">
            US (USA)
          </div>
          <p>
            Das Datum wird im Format MM/DD/JJJJ angezeigt, und der Dezimalseparator ist ebenfalls ein Punkt (.).
          </p>
        </li>
      </ul>
    </li>
    <li>
      <div class="mat-h3">
        Quote Char
      </div>
      <p>
        Eine Quote char (auch Anführungszeichen genannt) in einer CSV-Datei ist das Zeichen, das verwendet wird,
        um Text oder Felder einzuschließen.
        In CSV-Dateien wird das Doppelte Anführungszeichen (") oft als Quote-Zeichen verwendet.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Delimiter
      </div>
      <p>
        Der Delimiter ist das Zeichen, das die einzelnen Werte in der CSV-Datei voneinander trennt.
        Standardmäßig wird ein Komma (,) als Delimiter verwendet.
      </p>
    </li>
  </ul>
</div>
